import { mean } from './computeSummaryStats';
import { DailyMarketStats, ParsedOtaCsv } from './types';

function medianOf(sortedValues: ReadonlyArray<number>): number {
  const mid = Math.floor(sortedValues.length / 2);
  return sortedValues.length % 2 === 0 ? (sortedValues[mid - 1] + sortedValues[mid]) / 2 : sortedValues[mid];
}

/** Per-date LOW/AVERAGE/median across non-excluded OTA columns; blank (never 0) on a blackout date or all-blank row. */
export function computeDailyMarketStats(
  parsed: ParsedOtaCsv,
  excludedOtaColumns?: ReadonlySet<string>,
  blackoutDates?: ReadonlySet<string>,
): Array<DailyMarketStats> {
  return parsed.rows.map((row) => {
    if (blackoutDates?.has(row.date)) {
      return { date: row.date, low: null, average: null, median: null, sampleCount: 0 };
    }

    const values: Array<number> = [];
    for (const [col, value] of Object.entries(row.otaRates)) {
      if (value != null && !excludedOtaColumns?.has(col)) {
        values.push(value);
      }
    }

    if (values.length === 0) {
      return { date: row.date, low: null, average: null, median: null, sampleCount: 0 };
    }

    const sorted = [...values].sort((a, b) => a - b);
    return {
      date: row.date,
      low: sorted[0],
      average: mean(values),
      median: medianOf(sorted),
      sampleCount: values.length,
    };
  });
}
